// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector } from 'reselect';

import { RootState } from '../../rootReducer';

export const supportReducerListRaw = (state: RootState) => state.supportListReducer;

export const makeSupportListSelector = () => {
  return createSelector(
    supportReducerListRaw,
    (supportReducerListReducer) => supportReducerListReducer.list || []
  );
}
// export const makeSupportListDataByKey = (key: keyof supportReducer.initialState) => {
//   return createSelector(
//     supportReducerListRaw,
//     (supportReducerListReducer) => supportReducerListReducer.list[key]
//   );
// };

export const makeSupportListIsLoading = () => {
  return createSelector(
    supportReducerListRaw,
    (supportReducerListReducer) => supportReducerListReducer.isLoading
  );
}

export const makeSupportListError = () => {
  return createSelector(
    supportReducerListRaw,
    (supportReducerListReducer) => supportReducerListReducer.error
  );
}
